import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  if (document) {
    document.title = '404 | CVM Insights';
  }
  return (
    <Fragment>
      <h1>Oops... The page you&rsquo;re looking for doesn&rsquo;t exist</h1>
      <Link to="/">Go home</Link>
    </Fragment>
  );
};

export default NotFound;
